import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import IconButton from '@mui/material/IconButton';
import { theme } from '@openx/components-core/lib/theme/theme.ts';
import type { MouseEvent } from 'react';

export type DropdownButtonProps = {
  isOpen: boolean;
  toggleOpen: () => void;
};

export const DropdownButton = ({ isOpen, toggleOpen }: DropdownButtonProps) => {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    toggleOpen();
  };

  return (
    <IconButton
      sx={{ color: theme.palette.text.primary }}
      type="button"
      onClick={handleClick}
      data-test="section-toggle"
    >
      {isOpen ? (
        <KeyboardArrowUp data-test="keyboard-arrow-up" />
      ) : (
        <KeyboardArrowDown data-test="keyboard-arrow-down" />
      )}
    </IconButton>
  );
};
